// extracted by css-extract-rspack-plugin
var _1 = "ccU9vWN4k0M2WKRU";
var _2 = "vrfvFRO3QU3ld3SM";
var _3 = "N_AAhgr7OWUh9jzj";
var _4 = "N_AAhgr7OWUh9jzj";
var _5 = "A6PFNcSJ0TIwdFDh";
var _6 = "GpOxse_Hc0GdYLm6";
var _7 = "p2p22RYlBEQ0kwpW";
var _8 = "yqNtUlSBwU325DTt";
var _9 = "AjSB7RbKkrspjrQf";
var _a = "g6K8MEvWPfAhOTQQ";
var _b = "iA_SujXN88kHAUBj";
var _c = "TXhbn5Dqqo0zaWDL";
var _d = "TXhbn5Dqqo0zaWDL";
var _e = "OiInrVWoaj8KViuP";
var _f = "p6R4QqU0WWIPp22G";
var _10 = "LQC0gYK1IqT5ayYA";
var _11 = "dNJAUFYywgsCm7xF";
var _12 = "D5dyOSkkvFUm6vhy";
var _13 = "g0W2Ilq8tWMAmkoJ";
var _14 = "C4Mx8GrEdClZCsF4";
var _15 = "hhijw8pdQcct5WCu";
var _16 = "PjKcgCclnk04VIUp";
var _17 = "Ogjn9vp1qc6pJNxX";
var _18 = "Lgtzk2sCW83qiQfT";
var _19 = "EMeJuS32rPETwmIv";
var _1a = "OiInrVWoaj8KViuP";
var _1b = "p6R4QqU0WWIPp22G";
var _1c = "LQC0gYK1IqT5ayYA";
var _1d = "dNJAUFYywgsCm7xF";
var _1e = "D5dyOSkkvFUm6vhy";
var _1f = "g0W2Ilq8tWMAmkoJ";
var _20 = "C4Mx8GrEdClZCsF4";
var _21 = "hhijw8pdQcct5WCu";
var _22 = "PjKcgCclnk04VIUp";
var _23 = "Ogjn9vp1qc6pJNxX";
var _24 = "Lgtzk2sCW83qiQfT";
var _25 = "EMeJuS32rPETwmIv";
var _26 = "QUCdaN86cqg3G8RN";
var _27 = "ikSlxFNF2gIhD3WZ";
var _28 = "fJEGok0oJDgudr6J";
var _29 = "_E5hRNy9cg89g38N";
var _2a = "SaJzBkAsXio3MzQj";
var _2b = "HkXKQ1lQ1ckDp3c1";
var _2c = "n3r7y_7xVoEAiZvg";
var _2d = "ikSlxFNF2gIhD3WZ";
var _2e = "fJEGok0oJDgudr6J";
var _2f = "_E5hRNy9cg89g38N";
var _30 = "SaJzBkAsXio3MzQj";
var _31 = "HkXKQ1lQ1ckDp3c1";
var _32 = "n3r7y_7xVoEAiZvg";
var _33 = "fY8XlzS7oV0V2gUf";
var _34 = "LTzdOwo8iH06SQP0";
var _35 = "TS7MD2FGVEBoww0w";
export { _1 as "association", _2 as "body", _3 as "body-content", _4 as "bodyContent", _5 as "chip", _6 as "container", _7 as "duration", _8 as "header", _9 as "img", _a as "live", _b as "logo", _c as "logo-txt-fallback", _d as "logoTxtFallback", _e as "pk-card", _f as "pk-card--blocks-basic", _10 as "pk-card--blocks-large", _11 as "pk-card--blocks-mixed", _12 as "pk-card--btn", _13 as "pk-card--mosaic-adaptive", _14 as "pk-card--mosaic-single", _15 as "pk-card--square", _16 as "pk-card--square-over", _17 as "pk-card--square-under", _18 as "pk-card--wide", _19 as "pk-card--with-btn", _1a as "pkCard", _1b as "pkCardBlocksBasic", _1c as "pkCardBlocksLarge", _1d as "pkCardBlocksMixed", _1e as "pkCardBtn", _1f as "pkCardMosaicAdaptive", _20 as "pkCardMosaicSingle", _21 as "pkCardSquare", _22 as "pkCardSquareOver", _23 as "pkCardSquareUnder", _24 as "pkCardWide", _25 as "pkCardWithBtn", _26 as "roofline", _27 as "roofline-comp", _28 as "roofline-comp__name", _29 as "roofline-return-to-play-developing-football", _2a as "roofline-return-to-play-playing-football", _2b as "roofline-return-to-play-running-football", _2c as "roofline-return-to-play-supporting-football", _2d as "rooflineComp", _2e as "rooflineCompName", _2f as "rooflineReturnToPlayDevelopingFootball", _30 as "rooflineReturnToPlayPlayingFootball", _31 as "rooflineReturnToPlayRunningFootball", _32 as "rooflineReturnToPlaySupportingFootball", _33 as "title", _34 as "video", _35 as "videobig" }
